import React from 'react';
import './style.css';

const Music = () => {
  return (
    <div>
        <h1>"empty"</h1>
    </div>
    
  );
};

export default Music;
